var MobileModeHint = /*#__PURE__*/function (MobileModeHint) {
  MobileModeHint["Mobile"] = "mobile";
  MobileModeHint["NotMobile"] = "notMobile";
  return MobileModeHint;
}(MobileModeHint || {});

export { MobileModeHint as M };
//# sourceMappingURL=MobileModeHint-BwA4f8WD.js.map
